import type { Candidate } from '../repository'

import cardProductMeta from '@cogo/schema/blocks-v2/card/card-product/block.cogo.json'
import cardProductUi from '@cogo/schema/blocks-v2/card/card-product/ui.cogo.json'
import cardProductEvents from '@cogo/schema/blocks-v2/card/card-product/events.cogo.json'
import cardProductFlow from '@cogo/schema/blocks-v2/card/card-product/flow.cogo.json'
import cardProductVariables from '@cogo/schema/blocks-v2/card/card-product/variables.cogo.json'
import cardProductDatasource from '@cogo/schema/blocks-v2/card/card-product/datasource.cogo.json'
import { cloneBlockDef, appendRootClassName } from './util'

function buildCardVariant(variant: 'minimal' | 'withBadge' | 'horizontal') {
  const base = cloneBlockDef({
    meta: cardProductMeta,
    ui: cardProductUi,
    events: cardProductEvents,
    flow: cardProductFlow,
    state: cardProductVariables,
    data: cardProductDatasource,
  })
  if (variant === 'withBadge') appendRootClassName(base, 'ring-2 ring-primary')
  if (variant === 'horizontal') appendRootClassName(base, 'flex-row')
  return base
}

export const blockEditorCandidates: Candidate[] = [
  {
    id: 'block-editor-a',
    exampleId: 'cexample:card-product-minimal',
    patternId: 'cpat:product-card-grid',
    dsId: 'ds:shadcn',
    cogoJson: buildCardVariant('minimal'),
    narrativeHeadline: 'Minimal product card · clean layout',
    dsCompatibility: 'exact',
    score: 90,
  },
  {
    id: 'block-editor-b',
    exampleId: 'cexample:card-product-with-badge',
    patternId: 'cpat:product-card-grid',
    dsId: 'ds:shadcn',
    cogoJson: buildCardVariant('withBadge'),
    narrativeHeadline: 'Product card with highlight ring',
    dsCompatibility: 'exact',
    score: 85,
  },
  {
    id: 'block-editor-c',
    exampleId: 'cexample:card-product-horizontal',
    patternId: 'cpat:product-card-grid',
    dsId: 'ds:shadcn',
    cogoJson: buildCardVariant('horizontal'),
    narrativeHeadline: 'Horizontal product card · list layout',
    dsCompatibility: 'adjacent',
    score: 75,
  },
]
